import { clsx } from 'clsx'

interface ToggleProps {
  enabled: boolean
  onChange: (enabled: boolean) => void
  color?: 'primary' | 'wendy' | 'artem'
  label?: string
  disabled?: boolean
}

const bgColors: Record<string, string> = {
  primary: 'bg-primary-500',
  wendy: 'bg-wendy',
  artem: 'bg-artem',
}

export default function Toggle({ enabled, onChange, color = 'primary', label, disabled }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      aria-label={label}
      onClick={() => !disabled && onChange(!enabled)}
      disabled={disabled}
      className={clsx(
        'w-12 h-7 rounded-full relative transition-colors duration-200',
        enabled ? bgColors[color] : 'bg-neutral-200',
        disabled && 'opacity-50 cursor-not-allowed'
      )}
    >
      <span
        className={clsx(
          'absolute top-0.5 left-0.5 w-6 h-6 bg-white rounded-full shadow-md ring-1 ring-black/5 transition-transform duration-200',
          enabled ? 'translate-x-5' : 'translate-x-0'
        )}
      />
    </button>
  )
}
